import { GlobalButton } from "../../../../../global/forms/GlobalFormFields";
import {
  formatDisplayDate,
  formatMoney,
  isTournamentFull,
  slotsLabel,
  tournamentStatusByRegistrationClosingDate,
} from "../tournamentRegistrationHelpers";

export default function TournamentRegistrationTournamentsListSection({
  cardsWrapRef,
  loadingTournaments,
  displayedTournaments,
  labelFiltersSlot,
  onRegisterClick,
}) {
  return (
    <div ref={cardsWrapRef} className="treg-cards-wrap">
      {labelFiltersSlot}
      {loadingTournaments ? (
        <div className="treg-loading">Loading tournaments…</div>
      ) : displayedTournaments.length === 0 ? (
        <div className="treg-empty">No upcoming active tournaments are available right now.</div>
      ) : (
        <div className="treg-cards">
          {displayedTournaments.map((t) => {
            const full = isTournamentFull(t);
            const status = tournamentStatusByRegistrationClosingDate(t);
            const registerDisabled = full || !status.canRegister;
            return (
              <article
                key={t.id}
                className={`treg-card treg-card--${status.key}${full ? " treg-card--full" : ""}${!status.canRegister ? " treg-card--disabled" : ""}`}
              >
                <div className="treg-card__rail" aria-hidden>
                  <span className="treg-card__initial">{status.badge}</span>
                  <span className="treg-card__rail-line" />
                </div>
                <div className="treg-card__inner">
                  <div className="treg-card__col treg-card__col--main">
                    <div className="treg-card__top">
                      <span className="treg-card__sport">{t.sport_name || "Sport"}</span>
                      <span className="treg-card__status-tag">{status.label}</span>
                      {t.level_name ? <span className="treg-card__pill">{t.level_name}</span> : null}
                    </div>
                    <h3 className="treg-card__title">{t.tournament_name}</h3>
                    <div className="treg-card__summary-line">
                      <span className="treg-card__summary-item">
                        <span className="treg-card__summary-k">Fee</span>
                        <span className="treg-card__summary-v">{formatMoney(t.participation_fee)}</span>
                      </span>
                      <span className="treg-card__summary-dot" aria-hidden>
                        ·
                      </span>
                      <span className="treg-card__summary-item">
                        <span className="treg-card__summary-k">Slots</span>
                        <span
                          className={`treg-card__summary-v${full ? " treg-card__summary-v--warn" : ""}`}
                        >
                          {slotsLabel(t)}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="treg-card__cta">
                    <GlobalButton
                      type="button"
                      variant="primary"
                      disabled={registerDisabled}
                      onClick={() => onRegisterClick(t)}
                    >
                      {full
                        ? "Tournament full"
                        : !status.canRegister
                          ? "Ongoing - unavailable"
                          : "Register student"}
                    </GlobalButton>
                  </div>

                  <div className="treg-card__hover" aria-hidden>
                    <div className="treg-card__hover-head">
                      <span className="treg-card__hover-title">{t.tournament_name}</span>
                      <span className="treg-card__hover-pill">{t.sport_name || "Sport"}</span>
                    </div>
                    <dl className="treg-card__hover-facts">
                      <div>
                        <dt>Date</dt>
                        <dd>{formatDisplayDate(t.tournament_date)}</dd>
                      </div>
                      <div>
                        <dt>Reg closes</dt>
                        <dd>
                          {t.registration_last_date ? formatDisplayDate(t.registration_last_date) : "—"}
                        </dd>
                      </div>
                      {t.level_name ? (
                        <div>
                          <dt>Level</dt>
                          <dd>{t.level_name}</dd>
                        </div>
                      ) : null}
                      {t.tournament_code ? (
                        <div>
                          <dt>Code</dt>
                          <dd>{t.tournament_code}</dd>
                        </div>
                      ) : null}
                      <div className="treg-card__hover-facts-full">
                        <dt>Venue</dt>
                        <dd>{t.tournament_location || "—"}</dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
